<h2 mat-dialog-title>
  {{ 'CANCEL_PROCESS_QUESTION' | translate }}

  <button
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon fontIcon="close" />
  </button>
</h2>

<mat-dialog-content>
  {{ 'CANCEL_PROCESS_DESCRIPTION' | translate }}
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-button
    class="rs-btn--secondary"
    matDialogClose
  >{{ 'KEEP' | translate }}</button>
  <button
    data-testid="btn-confirm-cancel-process"
    mat-button
    class="rs-btn--primary"
    (click)="onSave()"
  >
    {{ 'CANCEL_PROCESS' | translate }}
  </button>
</mat-dialog-actions>